






































































































































import { Vue, Component, Watch } from "vue-property-decorator";
import {
  getCurrentCompanyId,
  getCurrentUserId,
  isRoot,
  currentUserIsCompanyOwner,
  getCurrentEmployee
} from "@/plugins/roles";
import employee, { EmployeeListParams } from "@/getinfo-api/employee";
import { Employee as IEmployee } from "@/api/models/employee";
import { EmployeesList2 as IEmployeesList2 } from "@/api/models/employees-list2";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import ExpulsionOrderListItem from "@/components/expulsion/ExpulsionOrderListItem.vue";
import { ExpulsionOrderShort as IExpulsionOrder } from "@/api/models/expulsion-order-short";
import { ExpulsionOrderShortList as IExpulsionOrderList } from "@/api/models/expulsion-order-short-list";
import expulsions, {
  ExpulsionOrdersListParam
} from "@/getinfo-api/expulsion-order";
import CustomButton from "@/components/form/CustomButton.vue";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CField from "@/components/form/CField.vue";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import { CoursesListClass } from "@/classes/list/CoursesListClass";

@Component({
  components: {
    CSingleSelect,
    CField,
    CPage,
    CustomDatepicker,
    ExpulsionOrderListItem,
    CustomButton
  }
})
export default class ExpulsionOrderList extends Vue {
  number!: string | undefined;
  signedAtMin!: Date | undefined;
  signedAtMax!: Date | undefined;
  courseId!: string | undefined;
  ownerId!: string | undefined;
  employees!: Array<IEmployee>;
  limit: number = 30;
  offset: number = 0;
  showSpinner: boolean = false;
  expulsionOrderList: Array<IExpulsionOrder> = [];
  expulsionOrderCount: number = 0;
  createdAtMin!: Date | undefined;
  createdAtMax!: Date | undefined;
  formedAtMin!: Date | undefined;
  formedAtMax!: Date | undefined;
  local: boolean = true;
  createdDataValue?: string;
  createdDataValueDouble?: string;
  gettingResult: boolean = false;
  signedAt: boolean | undefined;
  updatedAtMin!: Date | undefined;
  updatedAtMax!: Date | undefined;
  list: boolean = true;
  sortedBy: any = "formedAt";
  order?: "ASC" | "DESC" = "DESC";
  reset: boolean = true;
  courseClass: CoursesListClass = new CoursesListClass({});

  data() {
    return {
      updatedAtMin: undefined,
      updatedAtMax: undefined,
      signedAt: undefined,
      number: undefined,
      signedAtMin: undefined,
      signedAtMax: undefined,
      formedAtMax: undefined,
      formedAtMin: undefined,
      courseId: undefined,
      ownerId: undefined,
      employees: undefined,
      createdAtMin: undefined,
      createdAtMax: undefined
    };
  }

  get iconClass() {
    return this.order === "DESC"
      ? "fas fa-long-arrow-alt-down"
      : "fas fa-long-arrow-alt-up";
  }

  sortDocuments(sortType: any) {
    if (this.sortedBy === sortType) {
      this.order = this.order === "DESC" ? "ASC" : "DESC";
    } else {
      this.order = "DESC";
    }
    this.sortedBy = sortType;
    this.expulsionOrderList = [];
    this.searchExpulsionOrder(0);
  }

  deleteExpulsion() {
    this.applyFilter();
  }

  get changeText() {
    if (this.local) {
      return (this.createdDataValue = `${this.$tc(
        this.$translate.CreationDate
      )} ↓`);
    } else {
      return (this.createdDataValueDouble = `${this.$tc(
        this.$translate.CreationDate
      )} ↑`);
    }
  }

  get contentManager() {
    return this.$store.getters.roles.includes("content_manager");
  }

  created() {
    this.getContentManagers();
    this.searchExpulsionOrder();
  }

  showMore() {
    this.offset += this.limit;
    this.searchExpulsionOrder(this.offset);
  }

  searchExpulsionOrder(offset: number = 0) {
    this.showSpinner = true;
    this.gettingResult = true;
    let params: ExpulsionOrdersListParam = {
      courseIds: this.courseId ? [this.courseId] : undefined,
      number: this.number,
      companyId: this.selectedCompany,
      ownerId: this.ownerId,
      createdAtMin: this.createdAtMin,
      createdAtMax: this.createdAtMax,
      signedAtMin: this.signedAtMin,
      signedAtMax: this.signedAtMax,
      updatedAtMin: this.updatedAtMin,
      updatedAtMax: this.updatedAtMax,
      formedAtMax: this.formedAtMax,
      formedAtMin: this.formedAtMin,
      signedAt: this.signedAt,
      offset: offset,
      limit: this.limit,
      sort: this.sortedBy,
      order: this.order
    };

    expulsions(params)
      .then((res: { data: IExpulsionOrderList }) => {
        this.expulsionOrderCount = res.data.count;
        res.data.items?.forEach(el => {
          this.expulsionOrderList.push(el);
        });
      })
      .finally(() => {
        this.gettingResult = false;
        this.showSpinner = false;
      });
  }

  applyFilter() {
    this.expulsionOrderList = [];
    this.offset = 0;
    this.searchExpulsionOrder();
  }

  @Watch("selectedCompany")
  updateEmployees() {
    this.clearForm();
    this.getContentManagers();
  }

  clearForm() {
    this.courseId = undefined;
    this.ownerId = undefined;
    this.number = undefined;
    this.formedAtMax = undefined;
    this.formedAtMin = undefined;
    this.signedAt = undefined;
    this.updatedAtMax = undefined;
    this.signedAtMin = undefined;
    this.createdAtMin = undefined;
    this.createdAtMax = undefined;
    this.updatedAtMin = undefined;
    this.signedAtMax = undefined;
    this.expulsionOrderList = [];
    this.searchExpulsionOrder();
    this.reset = false;
    this.$nextTick(() => (this.reset = true));
  }

  get screenWidth() {
    return window.innerWidth;
  }

  get selectedCompany() {
    return getCurrentCompanyId();
  }

  getContentManagers() {
    let params: EmployeeListParams = {
      id: this.selectedCompany,
      roles: ["content_manager"],
      userIds: this.root || this.companyOwner ? undefined : [this.userId],
      limit: 500
    };

    employee(params).then((res: { data: IEmployeesList2 }) => {
      this.employees = res.data.employees;
    });
  }

  get root() {
    return isRoot();
  }

  get userId() {
    return getCurrentUserId();
  }

  get companyOwner() {
    return currentUserIsCompanyOwner();
  }

  get currentEmployee() {
    return getCurrentEmployee();
  }
}
